module.exports = __webpack_public_path__ + "img/pi-1-2.744a72c6.jpg";